class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((btn) =>
      btn.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
  this.notification.classList.add('animate', 'active');

  this.notification.addEventListener(
    'transitionend',
    () => {
      this.notification.focus();
      // Safeguard if trapFocus isn’t defined yet
      if (typeof trapFocus === 'function') {
        trapFocus(this.notification);
      }
    },
    { once: true }
  );

  document.body.addEventListener('click', this.onBodyClick);
}

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);
      const html = parsedState.sections?.[section.sourceId || section.id];
      if (!container || !html) return; // guard

      const inner = this.getSectionInnerHTML(html, section.selector);
      if (inner != null) container.innerHTML = inner;
    });

    if (this.header?.reveal) this.header.reveal();
    this.open();
  }

  // IMPORTANT: `sourceId` is what we asked Shopify to re-render.
  // `id` is the DOM node we replace on this page.
  getSectionsToRender() {
    // try default Dawn id first; if not present, use your custom id
    const hasDefaultBubble = !!document.getElementById('cart-icon-bubble');
    const bubbleId = hasDefaultBubble ? 'cart-icon-bubble' : 'dawn13-cart-icon-bubble';

    return [
      {
        // container in cart-notification.liquid
        id: 'cart-notification-product',
        // the inner item wrapper coming from cart-notification-product.liquid
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
        // section we requested on /cart/add
        sourceId: 'cart-notification-product'
      },
      {
        id: 'cart-notification-button',
        sourceId: 'cart-notification-button'
      },
      {
        id: bubbleId,
        // header section id to request
        sourceId: hasDefaultBubble ? 'cart-icon-bubble' : 'dawn13-cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('cart-notification', CartNotification);
